const allowedTags = [
	'a',
	'b',
	'i',
	'u',
	'em',
	'strong',
	'p',
	'br',
	'div',
	'span',
	'ul',
	'ol',
	'li',
	'img',
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
	'blockquote',
	'code',
	'pre',
	'hr'
]

/**
 * Function for sanitize html
 @param html html string
 */

export const sanitizeHTML = (html: string): string => {
	let sanitized = html

	// Удаляем <script> теги вместе с их содержимым.
	sanitized = sanitized.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')

	// Удаляем обработчики событий (атрибуты, начинающиеся с "on")
	sanitized = sanitized.replace(/\s*on\w+="[^"]*"/gi, '')
	sanitized = sanitized.replace(/\s*on\w+='[^']*'/gi, '')

	// Удаляем javascript: в атрибутах href и src
	sanitized = sanitized.replace(/(href|src)=("|\')\s*javascript:[^"']*("|\')/gi, '$1=$2#$3')

	// Удаляем опасные конструкции в атрибуте style (например, expression())
	sanitized = sanitized.replace(/style=("|\')[^"\']*expression\s*\([^"\']*\)[^"\']*("|\')/gi, '')

	// Удаляем теги, не входящие в белый список.
	// Для каждого тега, если его имя не содержится в списке, тег полностью удаляется.
	sanitized = sanitized.replace(/<\/?([a-z0-9]+)(\s[^>]*)?>/gi, (match, tagName) => {
		tagName = tagName.toLowerCase()
		return allowedTags.includes(tagName) ? match : ''
	})

	return sanitized
}
